import {
  tags_returned,
  user_signed_out,
  tag_received,
  tag_deleted,
  tag_updated
} from '../actions/types';

const INITIAL_STATE = {
  tagsLoading: true,
  tags: [],
  tagHash: {}
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case tags_returned: {
      const tagHash = {};
      action.payload.forEach(tag => tagHash[tag._id] = tag.name);
      return { ...state, tags: action.payload, tagHash, tagsLoading: false };
    }
    case user_signed_out:
      return { ...INITIAL_STATE };

    case tag_received: {
      let hash = state.tagHash;
      hash[action.payload._id] = action.payload.name;
      return { ...state, tags: [ ...state.tags, action.payload ], tagHash: hash };
    }

    case tag_deleted: {
      let tags = state.tags;
      let ids = tags.map((tag) => tag._id);
      tags.splice(ids.indexOf(action.payload), 1);
      let tagHash = state.tagHash;
      tagHash[action.payload] = null;
      return { ...state, tags: [ ...tags ], tagHash };
    }

    case tag_updated: {
      let tags = state.tags;
      let ids = tags.map((tag) => tag._id);
      tags[ids.indexOf(action.payload._id)] = action.payload;
      let tagHash = state.tagHash;
      tagHash[action.payload._id] = action.payload.name;
      return { ...state, tags: [ ...tags ], tagHash: { ...tagHash } };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/TagsReducer.js